import React from 'react';
import {
	StyledButton,
	StyledContainer,
	StyledExpandButton,
	StyledUfsList,
	StyledUfsWrapper,
} from './styles';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {ServicePointFilterProps} from './types';
import {useUfSelector} from './hooks/useUfSelector';
import {Skeleton} from '@mui/material';
import {Filter} from 'presentation/components/Filter';

const {all, open, close} = translations['pt-br'].commons;
const {placeholder} = translations['pt-br'].privateFlow.help.ourAddresses;

export function ServicePointFilter({ufs, isUfsLoading, isUfsError}: ServicePointFilterProps) {
	const {
		ufCode,
		ufsListRef,
		orderedUfsState,
		showExpandButton,
		isExpandedState,
		handleSelectUf,
		handleSelectAll,
		toggleExpand,
		isMobile,
		theme,
	} = useUfSelector(ufs);

	return (
		<StyledContainer px={isMobile ? 2 : 4} py={2} gap={1.5}>
			<Filter.Search placeholder={placeholder} readOnly={isUfsLoading} />

			{isUfsLoading ? <Skeleton variant="rounded" height={32} /> : null}

			{isUfsError || isUfsLoading ? null : (
				<StyledUfsWrapper>
					<StyledUfsList
						ref={ufsListRef}
						$isExpanded={isExpandedState}
						display="flex"
						flexWrap="wrap"
						gap={1}>
						<StyledButton
							variant={'outlined'}
							size="small"
							onClick={handleSelectAll}
							$isSelected={!ufCode}>
							{all}
						</StyledButton>

						{orderedUfsState.map(uf => (
							<StyledButton
								key={uf}
								variant={'outlined'}
								size="small"
								$isSelected={uf === ufCode}
								onClick={() => handleSelectUf(uf)}>
								{uf}
							</StyledButton>
						))}
					</StyledUfsList>

					{showExpandButton ? (
						<StyledExpandButton
							size="small"
							onClick={toggleExpand}
							aria-label={isExpandedState ? close : open}>
							<Icon
								name={isExpandedState ? 'expand-less-filled' : 'expand-more-filled'}
								size={22}
								color={theme.palette.primary.main}
							/>
						</StyledExpandButton>
					) : null}
				</StyledUfsWrapper>
			)}
		</StyledContainer>
	);
}
